/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UpdateTenantRequest {
    getFixupPrototypeFunction() { return UpdateTenantRequest.fixupPrototype; }

    static newInstance(model: Partial<UpdateTenantRequest>): UpdateTenantRequest {
        let obj = Object.assign(new UpdateTenantRequest(), model);
        UpdateTenantRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UpdateTenantRequest>): UpdateTenantRequest {
        if (!model) return null;
        return UpdateTenantRequest.newInstance(<UpdateTenantRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UpdateTenantRequest) {
        if (!obj) return;

        models.UpdateTenantRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UpdateTenantRequest): boolean {
        Object.setPrototypeOf(obj, UpdateTenantRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.fiscal_year_configuration) {
            models.FiscalYearConfiguration.fixupPrototype(this.fiscal_year_configuration);
        }
        if (this.cost_anomaly_settings) {
            models.CostAnomalyConfiguration.fixupPrototype(this.cost_anomaly_settings);
        }
        if (this.cost_processing_settings) {
            models.CostProcessingSettings.fixupPrototype(this.cost_processing_settings);
        }
        if (this.disk_utilization_settings) {
            models.DiskUtilizationSetting.fixupPrototype(this.disk_utilization_settings);
        }
        if (this.activity_queue_notifications) {
            models.ActivityQueueNotificationDetails.fixupPrototype(this.activity_queue_notifications);
        }
        if (this.email_notify) {
            models.EmailNotifyConfiguration.fixupPrototype(this.email_notify);
        }
        if (this.configuration_management) {
            models.TenantConfigurationManagementOptions.fixupPrototype(this.configuration_management);
        }
        if (this.dimension_settings) {
            for (let val of this.dimension_settings) {
                models.DimensionTenantSettings.fixupPrototype(val);
            }
        }
    }

    /**
     * New name for the tenant. Tenant Name must be unique within the account. Must be 3-100 characters. Special characters ' \" # ? / \\ are not allowed.
     */
    name: string;

    /**
     * Description of the the tenant.
     */
    description: string;

    /**
     * metadata is freeform JSON. It allows to store custom keys and values. It will be useful for storing information about an external applications that will refer to CoreStack tenant.
     */
    metadata: any;

    /**
     * Id of the CoreStack account under which the tenant to be updated.
     */
    account_id: string;

    /**
     * Fiscal Year settings
     */
    fiscal_year_configuration: models.FiscalYearConfiguration;

    cost_anomaly_settings: models.CostAnomalyConfiguration;

    cost_processing_settings: models.CostProcessingSettings;

    /**
     * azure hybrid benefits enabled under finOps
     */
    azure_hybrid_benefits_enabled: boolean;

    /**
     * enables disk utilization configuration for specified service accounts
     */
    disk_utilization_settings: models.DiskUtilizationSetting;

    /**
     * Dimension Settings for this Tenant
     */
    dimension_settings: Array<models.DimensionTenantSettings>;

    /**
     * Indicates the status of the Tenant
     */
    status: models.TenantStatus;

    activity_queue_notifications: models.ActivityQueueNotificationDetails;

    /**
     * Email notification configuration
     */
    email_notify: models.EmailNotifyConfiguration;

    configuration_management: models.TenantConfigurationManagementOptions;

}
